import type { mxCell } from '@deity-io/mxgraph';
import type { FlowContextInterface } from 'contexts/FlowContext';
import type { UIContextInterface } from 'contexts/UIContext';
import { META_KEY } from 'contracts/constants';
import { get } from 'lodash';
import type { GetPackageVersionQuery } from 'services/graphql/generated/operations';
import { replaceHandleBars } from 'utils/handlebarReplacement';

export function tooltipBuilder(
  cell: mxCell,
  packageVersion: GetPackageVersionQuery['getPackageVersion'],
  ctx: FlowContextInterface,
  ctxUI: UIContextInterface
) {
  try {
    if (cell.value?.compId && ctx?.state?.flow) {
      const component = ctx.state.flow.getComponent(cell.value.compId);
      const fullConfig = component ? ctx.state.flow.getFullRuntimeConfig(component) : {};
      // Todo, didn't I have this regex in a external file? don't want duplicate code, think i added the ':' in this one
      const handleBarsRegEx = /(\{(?<property>[\p{Letter}\p{Number}_\-.]+)(?<cast>:[\p{Letter}\p{Number}_\-.]+)?\})/giu;
      const returned = (cell.value?.detailedDescription || cell.value?.description || '').replace(
        handleBarsRegEx,
        match => {
          const matchPath = (match as string).slice(1, -1).split('.');
          let cast;
          const split = matchPath[matchPath.length - 1].split(':');
          if (split.length > 1) {
            matchPath[matchPath.length - 1] = split[0];
            cast = split[1];
          }

          const owner = matchPath.shift();

          switch (owner) {
            case 'this': {
              const value = get(fullConfig, matchPath);
              if (value !== undefined) {
                switch (cast) {
                  case 'structureUuid': {
                    const fn = ctx.state.flow?.getEntityCallback();
                    if (fn) {
                      const schema = fn('schema', value);
                      if (schema) {
                        return `<a href="/packages/${packageVersion.packageUuid}/${packageVersion.uuid}/structures/${value}">${schema[META_KEY]?.editor?.name}</a>`;
                      }
                    }

                    return `<a href="/packages/${packageVersion.packageUuid}/${packageVersion.uuid}/structures/${value}">${value}</a>`;
                  }
                  case 'structure':
                    // return `<a href="/packages/${params.packageId}/${params.versionUuid}/structures/${value[META_KEY]?.editor?.uuid}"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall css-ptiqhd-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="WidgetsIcon"><path d="M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z"></path></svg>${value[META_KEY]?.editor?.name}</a>`;
                    return `<a href="/packages/${packageVersion.packageUuid}/${packageVersion.uuid}/structures/${value[META_KEY]?.editor?.uuid}">${value[META_KEY]?.editor?.name}</a>`;
                  case 'mapping':
                    // return `<a href="/packages/${params.packageId}/${params.versionUuid}/mappings/${value[META_KEY]?.editor?.uuid}"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall css-ptiqhd-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="AccountTreeIcon"><path d="M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3z"></path></svg>${value[META_KEY]?.editor?.name}</a>`;
                    return `<a href="/packages/${packageVersion.packageUuid}/${packageVersion.uuid}/mappings/${value[META_KEY]?.editor?.uuid}">${value[META_KEY]?.editor?.name}</a>`;
                  case 'endpoint':
                    // return `<a href="/packages/${params.packageId}/${params.versionUuid}/endpoints/${value[META_KEY]?.editor?.uuid}"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall css-ptiqhd-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="OpenWithIcon"><path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path></svg>${value[META_KEY]?.editor?.name}</a>`;
                    return `<a href="/packages/${packageVersion.packageUuid}/${packageVersion.uuid}/endpoints/${value[META_KEY]?.editor?.uuid}">${value[META_KEY]?.editor?.name}</a>`;
                  case undefined:
                    return value;
                  default:
                    return value;
                }
              }

              return match;
            }
            case 'env': {
              const envVar = get(ctxUI?.state.currentEnvironment?.variables, matchPath);
              if (envVar) {
                return envVar;
              }

              return match;
            }
            case 'package': {
              const packageVar = get(packageVersion, matchPath);
              if (packageVar) {
                return packageVar;
              }

              return match;
            }
            default:
              return match;
          }
        }
      );
      if (ctxUI?.state.currentEnvironment && packageVersion.variables[ctxUI?.state.currentEnvironment.name]) {
        const double = replaceHandleBars(returned, {
          variables: packageVersion.variables[ctxUI?.state.currentEnvironment.name]
        });

        return double;
      }

      // const double = replaceHandleBars(returned,{variables:})
      return returned;
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(`Error encountered getting tooltip for cell ${cell.value?.compId}. Message "${err}"`);
  }
}
